import { Driver, Order } from '@apis/index'
import Button from '@components/button'
import { Status, TableActions } from '@components/index'
import Table from '@components/table'
import { IDefaultParams } from '@pages/admin/types'
import { Actions, store } from '@store/index'
import { searchHandler } from '@utils/index'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { StyleBackDropWrapper, StyleModalWrapper, StyleWrapper } from './style'

interface IAssignModal {
  onCancel: () => void
  visible: boolean
  setVisible: any
  order: any
  isPending?: boolean
  isLend?: boolean
}
const AssignModal = ({
  onCancel,
  visible = false,
  setVisible,
  order,
  isPending,
  isLend,
}: IAssignModal) => {
  const debounceRef: any = useRef()
  const { items: drivers } = useSelector((state: any) => state.drivers)
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
    status: 'Available',
  })
  const fetchDrivers = async (params: IDefaultParams) => {
    await Driver.getAll(params).catch(() => {})
  }
  useEffect(() => {
    if (!drivers?.length && !!visible) {
      fetchDrivers(params)
    }
    return () => {
      store.dispatch(Actions.reset('drivers'))
    }
  }, [visible])
  const onAssign = async (driver: any) => {
    const payload: any = {}
    if (order?.returnDate) {
      payload.driverReturn = driver?.id
      await Order.returnDriver(payload, order.id)
        .then(() => {
          isLend && store.dispatch(Actions.remove('orders', order))
          setVisible(false)
        })
        .catch(() => {})
        .finally(() => {})
    }
    if (!order?.returnDate) {
      payload.driverPickUp = driver?.id
      await Order.pickupDriver(payload, order.id)
        .then(() => {
          !!isPending && store.dispatch(Actions.remove('orders', order))
          setVisible(false)
        })
        .catch(() => {})
        .finally(() => {})
    }
  }
  const columns = [
    {
      title: 'Name',
      key: 'name',
    },
    {
      title: 'Phone Number',
      key: 'phoneNo',
    },
    {
      title: 'Address',
      key: 'address',
    },
    {
      title: 'Status',
      key: 'status',
      render: (item: any) => {
        return <Status status={item?.status} />
      },
    },
    {
      title: 'Action',
      key: 'acton',
      render: (item: any) => {
        return (
          <TableActions
            hasCustom
            hasEdit={false}
            hasDelete={false}
            hasView={false}
            customTitle="Assign"
            onCustom={() => {
              onAssign(item)
            }}
          />
        )
      },
    },
  ]
  const onSearch = searchHandler({
    fetchFunction: fetchDrivers,
    paramKey: 'search',
    debounceTime: 600,
    params,
    setParams,
    debounceRef,
  })
  return (
    <>
      {!!visible && (
        <StyleWrapper>
          <StyleBackDropWrapper>
            <StyleModalWrapper>
              <Table
                tableTitle="Driver List"
                data={drivers}
                columns={columns}
                filter={{
                  hasSearch: true,
                  hasFilter: true,
                  onSearch: onSearch,

                  rightComponent: (
                    <Button title="Cancel" onClick={onCancel} type="button" />
                  ),
                }}
              />
            </StyleModalWrapper>
          </StyleBackDropWrapper>
        </StyleWrapper>
      )}
    </>
  )
}

export default AssignModal
